import React, { useState, useEffect } from 'react';
import { getStoredEvents, clearEvents } from '../services/track';
import Button from '../components/Button';
import { Download, Trash2, ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const DebugTrackPage = () => {
  const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    setEvents(getStoredEvents());
  }, []);

  const handleDownload = () => {
    const blob = new Blob([JSON.stringify(events, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `fpt_events_${new Date().getTime()}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleClear = () => {
    if (confirm('Clear all captured events?')) {
      clearEvents();
      setEvents([]);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-brand-grey2 hover:text-brand-cyan mb-8">
          <ChevronLeft className="w-4 h-4 mr-1" /> Home
        </Link>
        
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-heading font-bold text-brand-white">Event Log</h1>
          <div className="flex gap-4">
            <Button variant="outline" size="sm" onClick={handleClear}>
              <Trash2 className="w-4 h-4 mr-2" /> Clear
            </Button>
            <Button size="sm" onClick={handleDownload}>
              <Download className="w-4 h-4 mr-2" /> Export JSON
            </Button>
          </div>
        </div>

        <div className="bg-brand-dark border border-brand-border rounded-xl overflow-hidden">
          {events.length === 0 ? (
            <div className="p-20 text-center text-brand-grey2 italic">No events recorded.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm text-brand-grey1">
                <thead className="bg-brand-light text-brand-white uppercase text-xs font-semibold tracking-wider">
                  <tr>
                    <th className="px-6 py-4">Timestamp</th>
                    <th className="px-6 py-4">Event</th>
                    <th className="px-6 py-4">Payload</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-brand-border">
                  {events.slice().reverse().map((ev, i) => (
                    <tr key={i} className="hover:bg-brand-light/20 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap opacity-50">{new Date(ev.timestamp).toLocaleTimeString()}</td>
                      <td className="px-6 py-4 font-semibold text-brand-cyan">{ev.event}</td>
                      <td className="px-6 py-4 truncate max-w-xs">{JSON.stringify(ev.payload)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DebugTrackPage;
